import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "displaymode-text"
}

import { CompanyAssessmentQuestionType } from "@/dto";
import { companyAssessmentInputProps } from "./companyAssessmentInputProps";
import { onBeforeMount } from "vue";
import { computed } from "vue";
import type { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyAssessmentFormText',
  props: {
	modelValue: {
		type: String as PropType<string | null>,
		required: true,
	},
	...companyAssessmentInputProps,
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const modelValue = computed({
	get: () => props.modelValue,
	set: (value: string | null) => emit("update:modelValue", value),
});

onBeforeMount(() => {
	if (modelValue.value === null) {
		modelValue.value = "";
	}
});

return (_ctx: any,_cache: any) => {
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.displayMode)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(modelValue.value), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.question.questionType == _unref(CompanyAssessmentQuestionType).Text)
            ? (_openBlock(), _createBlock(_component_HakoInput, _mergeProps({
                key: 0,
                type: _ctx.displayMode ? 'text' : 'textarea',
                disabled: _ctx.displayMode,
                class: "form-control"
              }, _ctx.$attrs, {
                modelValue: modelValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
              }), null, 16, ["type", "disabled", "modelValue"]))
            : (_ctx.question.questionType == _unref(CompanyAssessmentQuestionType).TextArea)
              ? (_openBlock(), _createBlock(_component_HakoTextArea, _mergeProps({
                  key: 1,
                  disabled: _ctx.displayMode,
                  class: "form-control"
                }, _ctx.$attrs, {
                  modelValue: modelValue.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event))
                }), null, 16, ["disabled", "modelValue"]))
              : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})